import { httpRequest } from "@services/http";

export interface PreviewAudiencePayload {
  rules: Record<string, any>;
}

export interface PreviewAudienceResponse {
  preview_count: number;
  sample_ids?: number[];
}

export class CommandPreviewAudience {
  async run(audienceId: number, payload: PreviewAudiencePayload): Promise<PreviewAudienceResponse> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/audiences/${audienceId}/preview/`;

    const response = await httpRequest<PreviewAudienceResponse>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });

    return response;
  }
}